import gsap from 'gsap';
import Cookies from 'js-cookie'
import {isJson} from "../helpers";

const {__, _x, _n, _nx} = wp.i18n;

class Cart {
    constructor() {

        this.cart = document.querySelector('.cart');
        if (!this.cart) return false;

        this.cartList = document.querySelector('.cart__list');
        this.orderInput = document.querySelector('.cart__order input');
        this.timestampID = Date.now();
        this.cartIconEl = document.querySelector('.cart__icon');
        this.adToCart = document.querySelectorAll('.add-to-cart');
        this.cartCloseBtn = document.querySelector('.cart__close');
        this.currencySwitcher = document.querySelector('.currency-toggle input');
        this.addCloudStorageField = document.querySelector('.gf-cart__cloud select');
        this.messageField = document.querySelector('.gf-cart__message input');
        this.submitBtn = document.querySelector('.cart input[type="submit"]');

        this.init();
        this.events();
    }

    init() {

        if (Cookies.get('ax_cart')) {
            this.renderFromCookie();
            this.calcTotalPrice();
            this.orderInput.value = JSON.stringify(this.generateOrderInput(JSON.parse(Cookies.get('ax_cart'))));

            // if (Cookies.get('ax_cart_cloud')) {
            //     this.setCloudField();
            // } else {
            //     this.addCloudStorage();
            // }

        }
        this.toggleCloudCurrency();
    }

    events() {
        this.cartIconEl.addEventListener('click', this.cartShow.bind(this));
        this.adToCart.forEach(btn => btn.addEventListener('click', this.add.bind(this)));
        this.cartList.addEventListener('click', this.remove.bind(this));
        this.cartCloseBtn.addEventListener('click', this.cartHide.bind(this))

        this.currencySwitcher?.addEventListener('change', this.exchangeRate.bind(this));
        this.submitBtn?.addEventListener('click', this.removeCookie.bind(this))
        // this.addCloudStorageField?.addEventListener('change', this.addCloudStorage.bind(this));
    }

    removeCookie() {
        Cookies.remove('ax_cart')
    }

    renderFromCookie() {
        const cookieData = JSON.parse(Cookies.get('ax_cart'));

        for (const [timestampID, item] of Object.entries(cookieData)) {
            if (timestampID === 'storage') continue;
            this.timestampID = timestampID;
            const panel = item.panel ? item.panel.name : '';
            const cartItemHTML = this.renderCartItem({
                tariff: item.tariffID,
                totalPrice: item.price,
                paramsContent: [
                    item.cpu,
                    item.ram,
                    item.drives,
                    item.raid,
                    panel
                ],
                currency: item.currency,
                offerType: item.offerType
            });

            this.cartList.insertAdjacentHTML('beforeend', cartItemHTML);
            this.quantityHandler()
        }
    }

    addCloudStorage() {
        const cloudBackupField = $('.gf-cart__cloud option:selected');
        const cloudStorage = cloudBackupField.val()
            ? JSON.parse(cloudBackupField.val())
            : {volume: "", price: "0", currency: "RUB", unit: ""};
        setTimeout(() => {
            if (this.orderInput.value) {
                const order = JSON.parse(this.orderInput.value);
                if (cloudStorage.volume) {
                    order['storage'] = cloudStorage;
                    this.orderInput.value = JSON.stringify(order)
                }
            }
        }, 1)
    }

    setCloudField() {
        const cookieCloud = JSON.parse(Cookies.get('ax_cart_cloud'));
        this.addCloudStorageField?.querySelectorAll('option').forEach(option => {
            const currentOptionVolume = JSON.parse(option.value).volume;
            if (cookieCloud.volume === currentOptionVolume) {
                option.setAttribute('selected', 'selected');
            }
        });
        const order = JSON.parse(this.orderInput.value);
        order['storage'] = cookieCloud;
        this.orderInput.value = JSON.stringify(order)
    }

    cartHide() {
        this.cart.classList.remove('cart--active')
        if (window.matchMedia('(max-width: 480px)').matches) {
            this.cart.closest('body').classList.remove('scroll-disable');
        }
    }

    cartShow() {
        this.cart.classList.toggle('cart--active')
        if (window.matchMedia('(max-width: 480px)').matches) {
            this.cart.closest('body').classList.add('scroll-disable');
        }
    }

    calcTotalPrice() {
        const products = this.cartList.querySelectorAll('.cart__item');

        let price = 0;

        products.forEach(product => {
            price += +product.querySelector('.cart__item-price').dataset.price;
        })
        const prices = this.calcTotalPriceByCurrency(products);

        this.renderTotalPrice(prices);
    }

    renderTotalPrice(prices) {
        const cartTotalEl = document.querySelector('.cart__total');
        cartTotalEl.textContent = '';

        const items = [];

        for (const [currency, value] of Object.entries(prices)) {
            const currencyText = currency === 'rub' ? __('руб.', 'atlex') : __('евро', 'atlex');
            const localStringAtts = currency === 'rub' ? 'ru-RU' : 'en-GB';

            Object.keys(value).forEach(key => {
                if (value[key]) {
                    const totalCurrencyEl = key === 'rent'
                        ? `<span class="cart__total-currency" data-currency="${currency.toLowerCase()}">${currencyText}</span>/<span class="cart__item-period">${__('мес.', 'atlex')}</span>`
                        : `<span class="cart__total-currency" data-currency="${currency.toLowerCase()}">${currencyText}</span>`
                    items.push(`
                    <div class="cart__total-item">
                        <span class="cart__total-price" data-price="${value[key]}">${value[key].toLocaleString(localStringAtts)}</span>
                        ${totalCurrencyEl}
                    </div>
                `);
                }
            })
        }

        let priceHTML = this.cartList.children.length !== 0 ? `<span class="cart__total-caption">${__('Итого', 'atlex')}:</span>` : '';
        priceHTML += items.join('<span class="cart__total-divider">+</span>');

        cartTotalEl.insertAdjacentHTML('beforeend', priceHTML);
    }

    calcTotalPriceByCurrency(products) {
        let prices = {
            rub: {
                rent: 0,
                sale: 0,
            },
            eur: {
                rent: 0,
                sale: 0,
            }
        };
        products.forEach(product => {
            prices[product.dataset.currency.toLowerCase()][product.dataset.offerType] += +product.querySelector('.cart__item-price').dataset.price;
        })
        return prices;
    }

    toggleCartVisibility(quantity) {
        if (quantity === 0) {
            this.cartHide();
            this.cart.classList.remove('cart--enabled')
        } else {
            this.cart.classList.add('cart--enabled')
        }
    }

    quantityHandler(event) {
        const quantityEl = document.querySelector('.cart__quantity');
        let quantity = +document.querySelector('.cart__quantity').dataset.quantity;

        if (!event) {
            quantity = document.querySelectorAll('.cart__item');
            quantityEl.setAttribute('data-quantity', quantity.length);
            quantityEl.textContent = quantity.length;
            this.toggleCartVisibility(quantity);
            return false
        }

        if (event === 'add') {
            quantity += 1;
        } else if (event === 'subtract') {
            quantity -= 1;
        }

        this.toggleCartVisibility(quantity);

        quantityEl.setAttribute('data-quantity', quantity);
        quantityEl.textContent = quantity;
    }

    remove(e) {
        if (e.target.classList.contains('cart__remove')) {
            const id = e.target.closest('.cart__item').dataset.id;

            let orderFromCookie = JSON.parse(Cookies.get('ax_cart'));

            const asArray = Object.entries(orderFromCookie);

            const filtered = asArray.filter(([key, value]) => key !== id);

            orderFromCookie = Object.fromEntries(filtered);

            Cookies.set('ax_cart', orderFromCookie);

            e.target.closest('.cart__item').remove()
            this.quantityHandler('subtract');
            this.calcTotalPrice();
            this.updateOrder(id);
        }
    }

    add(e) {
        this.timestampID = Date.now();
        const product = e.target.closest('.dedic-card');
        const btn = product.querySelector('.dedic-card__btn');

        this.animateToAddCartBtn(btn);
        this.renderProductHTML(product);
        // this.addCloudStorage()
        this.calcTotalPrice();
        // this.addMessageToCart(product);

        this.storeOrder(product);
    }

    animateToAddCartBtn(btn) {
        const text = btn.querySelector('span');
        const icon = btn.querySelector('svg');
        const circle = btn.querySelector('.dedic-card__icon-circle');
        const check = btn.querySelector('.dedic-card__icon-check');
        const dot = btn.closest('.dedic-card').querySelector('.dedic-card__dot');
        const dotPos = dot.getBoundingClientRect();
        const cartIconPos = this.cartIconEl.getBoundingClientRect();
        const tl = gsap.timeline({defaults: {duration: 0.5, ease: 'Power1.easeOut'}});
        const tlDot = gsap.timeline({onComplete: this.quantityHandler.bind(this, 'add')});
        tlDot.to(dot, {
            x: cartIconPos.left - dotPos.left,
            y: cartIconPos.top - dotPos.top,
            duration: 0.75,
            ease: 'Back.easeOuteaseOut.config(22)',
            clearProps: 'x,y'
        })
            .to('.cart__quantity', {scale: 1.2, yoyo: true, repeat: 1, ease: 'Bounce.easeOut'})

        tl.to(btn, {pointerEvents: 'none', duration: 0})
            .to(text, {opacity: 0, duration: 0.3}, 0)
            .to(icon, {opacity: 1, duration: 0.3}, '<10%')
            .fromTo(circle, {strokeDashoffset: 1000}, {strokeDashoffset: 0})
            .fromTo(check, {strokeDashoffset: -100}, {strokeDashoffset: 0}, '<25%')
            .to(icon, {opacity: 0, duration: 0.3, delay: 0.5})
            .to(text, {opacity: 1, duration: 0.3})
            .to(btn, {pointerEvents: 'auto', duration: 0})
    }

    generateOrderInput(orderContent) {

        let objOrder = {}

        Object.keys(orderContent).map(id => {

            if (id !== 'storage') {
                let params = [];
                Object.keys(orderContent[id]).filter((key) => {
                  if (['cpu', 'ram', 'drives', 'raid'].includes(key)) {
                        return params.push(orderContent[id][key]);
                    }
                });
                const panel = orderContent[id]['panel'] ? orderContent[id]['panel'] : ''
                objOrder = {
                    ...objOrder, ...{
                        [id]: {
                            name: `${orderContent[id].tariffID}, ${params.join(', ')}`,
                            price: orderContent[id].price,
                            period: orderContent[id].period,
                            currency: orderContent[id].currency,
                            regionid: orderContent[id].regionId,
                            offerType: orderContent[id].offerType,
                            ...(panel && { panel })
                        }
                    }
                };
                if (orderContent[id].priceHidden) {
                    objOrder[id]['priceHidden'] = orderContent[id].priceHidden
                }
            }
        })
        return objOrder;
    }

    storeOrder(product) {

        let orderContent = this.orderInput.value
            ? JSON.parse(this.orderInput.value)
            : {};
        orderContent = {...orderContent, ...this.generateOrder(product, this.timestampID)};

        if (Cookies.get('ax_cart')) {
            orderContent = {...orderContent, ...JSON.parse(Cookies.get('ax_cart'))}
            Cookies.set('ax_cart', JSON.stringify(orderContent));
        } else {
            Cookies.set('ax_cart', JSON.stringify(orderContent));
        }

        const objOrder = this.generateOrderInput(orderContent);

        this.orderInput.value = JSON.stringify(objOrder);
    }

    addPanel(dedic) {
        const panel = dedic.querySelector('[data-name="panel"]');
        if(!panel || panel.value === '0') return false;

        const region = dedic.dataset.location === 'ru' ? 1 : 2;
        const currency = dedic.dataset.currency;
        const panelSelected = panel.options[panel.selectedIndex];
        const price = panelSelected.dataset.price;
        const mnemoname = panelSelected.dataset.mnemoname;
        const name = JSON.parse(panelSelected.value).name;

        return {
            aclassid: 10020,
            ordermnemoname: mnemoname,
            name: name,
            price: price,
            currency: currency,
            region: region,
            period: 1,
        }
    }

    updateOrder(id) {
        let orderContent = this.orderInput.value
            ? JSON.parse(this.orderInput.value)
            : {}

        delete orderContent[id];
        this.orderInput.value = JSON.stringify(orderContent);
    }

    renderProductHTML(product) {
        const offerType = product.dataset.offerType;
        const currency = product.dataset.currency;

        const params = product.querySelectorAll('select');
        let paramsContent = [];
        params.forEach(param => {
            const selectedId = param.selectedIndex;
            const currentParam = JSON.parse(param.options[selectedId].value);
            const arg = param.dataset.name;
            paramsContent.push(...this.renderCartParam(arg, currentParam));
        });
        const dedicPrice = product.querySelector('.dedic-card__price-value')
            ? +product.querySelector('.dedic-card__price-value').dataset.price
            : 0
        const dedicTariff = product.querySelector('.dedic-card__tariff').textContent;

        const cartItemObj = {
            tariff: dedicTariff,
            totalPrice: dedicPrice,
            paramsContent: paramsContent,
            offerType,
            currency
        };

        const cartItemHTML = this.renderCartItem(cartItemObj);
        this.cartList.insertAdjacentHTML('beforeend', cartItemHTML);
    }

    renderCartItem(cartItemObj) {
        const period = cartItemObj.offerType === 'rent' ? __('мес.', 'atlex') : '';
        const periodEl = period ? `/<span class="cart__item-period">${period}</span>` : '';

        const currency = cartItemObj.currency.toLowerCase() === 'rub' ? __('руб.', 'atlex') : __('евро', 'atlex');
        const currencyEl = `<span class="cart__item-currency" data-currency="${cartItemObj.currency.toLowerCase()}">${currency}</span>`;

        const localStringAtts = cartItemObj.currency.toLowerCase() === 'rub' ? 'ru-RU' : 'en-GB';

        const price = +cartItemObj.totalPrice;
        const paramsContent = cartItemObj.paramsContent.filter(item => item).join('<br>');
        const priceEl = cartItemObj.totalPrice
            ? `<span class="cart__item-price" data-price="${price}">${price.toLocaleString(localStringAtts)}</span>
               ${currencyEl}${periodEl}`
            : `<span class="cart__item-price" data-price="${price}">${__('стоимость по запросу', 'atlex')}</span>`
        return `<li class="cart__item" 
                            data-id="${this.timestampID}" 
                            data-offer-type="${cartItemObj.offerType}" 
                            data-currency="${cartItemObj.currency.toLowerCase()}"
                            data-period="${period}">
                    <div class="cart__item-content">
                        <div class="cart__item-title">${cartItemObj.tariff}</div>
                        <div class="cart__item-params">${paramsContent}</div>
                    </div>
                    <div class="cart__item-meta">${priceEl}</div>
                    <button class="cart__remove"></button>
                </li>`;
    }

    renderCartParam(arg, currentParam) {
        let paramsContent = [];
        switch (arg) {
            case 'cpu':
                paramsContent.push(`${currentParam.name}`);
                // paramsContent.push(`${currentParam.name} / ${currentParam.cores} / ${currentParam.frequency} / ${currentParam.benchmark}`);
                break;
            case 'ram':
                paramsContent.push(`${currentParam.volume} ${currentParam.unit.toUpperCase()}`);
                break;
            case 'drives':
                if (+currentParam.volume) {
                    paramsContent.push(`${currentParam.volume} ${currentParam.unit.toUpperCase()} ${currentParam.type.toUpperCase()}`);
                }
                break;
            case 'raid':
                paramsContent.push(`${currentParam.name}`);
                break;
            case 'panel':
                paramsContent.push(`${currentParam.name}`);
                break;
        }
        return paramsContent != 'undefined' ? paramsContent : '';
    }

    generateOrder(dedic, timestampID) {
        this.localStringAtts = dedic.dataset.location === 'ru' ? 'ru-RU' : 'en-GB';
        const regionId = dedic.dataset.location === 'ru' ? 1 : 2;
        const currency = dedic.dataset.location === 'ru' ? 'RUB' : 'EUR';
        const price = dedic.querySelector('.dedic-card__price-value')
            ? dedic.querySelector('.dedic-card__price-value').dataset.price
            : 0;
        const tariff = dedic.querySelector('.dedic-card__tariff').textContent.trim();
        const offerType = dedic.dataset.offerType;
        const ram = this.getRam(dedic.querySelectorAll('[data-name="ram"]'));
        const cpu = this.getCPU(dedic.querySelectorAll('[data-name="cpu"]'));
        const drives = this.getDrives(dedic.querySelectorAll('[data-name="drives"]'));
        const raid = this.getRaid(dedic.querySelectorAll('[data-name="raid"]'));

      const panel = this.addPanel(dedic);

        const order = {
            [timestampID]: {
                tariffID: tariff,
                cpu,
                ram,
                drives,
                raid,
                // panel,
                // name: [...[`id: ${tariff}`, ram, cpu, drives, raid]].join(', '),
                // name: [...[tariff, ram, cpu, drives, raid]].join(', '),
                price: price,
                period: 1,
                currency: currency,
                regionId: regionId,
                offerType: offerType,
                priceHidden: dedic.dataset.priceHidden,
                ...(panel && { panel })
            }
        };

        return order;
    }

    getCPU(arg) {
        let paramsContent = [];
        arg.forEach(param => {
            const selectedId = param.selectedIndex;
            const currentParam = JSON.parse(param.options[selectedId].value);
            paramsContent.push(currentParam.name)
        })
        return paramsContent.length ? `CPU: ${paramsContent.join(', ')}` : '';
    }

    getRam(arg) {
        let paramsContent = [];
        arg.forEach(param => {
            const selectedId = param.selectedIndex;
            const currentParam = JSON.parse(param.options[selectedId].value);
            paramsContent.push(`${currentParam.volume} ${currentParam.unit.toUpperCase()}`)
        })
        return paramsContent.length ? `RAM: ${paramsContent.join(', ')}` : '';
    }

    getDrives(arg) {
        let paramsContent = [];
        arg.forEach(param => {
            const selectedId = param.selectedIndex;
            const currentParam = JSON.parse(param.options[selectedId].value);
            if (+currentParam.volume) {
                paramsContent.push(`${currentParam.volume} ${currentParam.unit.toUpperCase()} ${currentParam.type.toUpperCase()}`)
            }
        });
        return paramsContent.length ? `Drives: ${paramsContent.join(', ')}` : '';
    }

    getRaid(arg) {
        let paramsContent = [];
        arg.forEach(param => {
            const selectedId = param.selectedIndex;
            const currentParam = JSON.parse(param.options[selectedId].value);
            paramsContent.push(currentParam.name)
        })
        return paramsContent.length ? `RAID: ${paramsContent.join(', ')}` : '';
    }

    getPanel(arg) {
        let paramsContent = [];
        arg.forEach(param => {
            const selectedId = param.selectedIndex;
            const currentParam = JSON.parse(param.options[selectedId].value);
            if(currentParam) {
              paramsContent.push(currentParam.name)
            }
        })
        return paramsContent.length ? `Panel: ${paramsContent.join(', ')}` : '';
    }

    exchangeRate() {
        if (!this.currencySwitcher) return false;

        const isRUB = this.currencySwitcher.checked;
        const currency = isRUB ? __('руб.', 'atlex') : __('евро', 'atlex')
        const localStringAtts = isRUB ? 'ru-RU' : 'en-GB';

        const dedicTotalPrices = document.querySelectorAll('.dedic-card__price')
        // Recalc total prices
        dedicTotalPrices.forEach(el => {
            const priceEl = el.querySelector('.dedic-card__price-value');
            const currencyEl = el.querySelector('.dedic-card__price-currency');

            let price = priceEl.dataset.price;

            if (isRUB) {
                price = price * ATLEX_OBJ.exchange_rate.eur;
            }
            priceEl.textContent = price.toLocaleString(localStringAtts);
            currencyEl.textContent = currency;
        });

        const cartItemPrices = document.querySelectorAll('.cart__item');
        const totalPricesCartEl = document.querySelectorAll('.cart__total-item');
        this.exchangeCartItems([...totalPricesCartEl, ...cartItemPrices])
        this.toggleCloudCurrency()
    }

    exchangeCartItems(array) {
        array.forEach(el => {
            const totalPriceEl = el.querySelector('[data-price]');
            if (+totalPriceEl.dataset.price) {
                const isRUB = this.currencySwitcher.checked;
                const currencyEl = el.querySelector('[data-currency]');
                const isCurrencyEur = currencyEl.dataset.currency === 'eur';
                const currency = isRUB ? __('руб.', 'atlex') : __('евро', 'atlex')
                let localStringAtts = !isCurrencyEur ? 'ru-RU' : 'en-GB';

                let price = +totalPriceEl.dataset.price;
                if (isRUB && isCurrencyEur) {
                    localStringAtts = 'ru-RU';
                    price = price * ATLEX_OBJ.exchange_rate.eur;
                    currencyEl.textContent = currency;
                }
                currencyEl.textContent = currencyEl.dataset.currency === 'eur' && !isRUB ? __('евро', 'atlex') : __('руб.', 'atlex')
                totalPriceEl.textContent = price.toLocaleString(localStringAtts);
            }
        });
    }

    toggleCloudCurrency() {

        const currencySwitcher = document.querySelector('.currency-toggle');

        if (!currencySwitcher) {
            return false;
        }

        const isCurrencyRub = document.querySelector('.currency-toggle input').checked;
        const cloudPrices = document.querySelectorAll('.gf-dedic-server__cloud:not([style*="display:none"]) option');

        let currency;
        const unit = __('GB', 'atlex');
        if (isCurrencyRub) {
            currency = __('руб/мес.', 'atlex');
        } else {
            currency = __('евро/мес.', 'atlex');
        }

        cloudPrices.forEach((item, id) => {
            if (isJson(item.value)) {
                const cloud = JSON.parse(item.value);
                let label = '';
                if (+cloud.price && !isCurrencyRub) {
                    const value = parseFloat(cloud.price / ATLEX_OBJ.exchange_rate.eur).toFixed(2);
                    label = `${cloud.volume} ${unit} — ${value} ${currency}`;
                    item.textContent = label;
                } else if (+cloud.price && isCurrencyRub) {
                    label = `${cloud.volume} ${unit} — ${cloud.price} ${currency}`;
                    item.textContent = label;
                }
            }
        })
    }

    // addMessageToCart(product) {
    //     const panel = product.querySelector('[data-name="panel"]');
    //     const currency = product.dataset.currency;
    //
    //     if(!panel || panel.value === '0') return false;
    //
    //     const obj = isJson(this.messageField.value) ? JSON.parse(this.messageField.value) : {[panel.dataset.name]: []};
    //     const price = panel.options[panel.selectedIndex].dataset.price;
    //
    //     obj[panel.dataset.name].push({ ...JSON.parse(panel.value), ...{price: price, currency: currency } })
    //
    //     if(Object.keys(obj).length) {
    //         this.messageField.value = JSON.stringify(obj);
    //     }
    //
    //     Cookies.set('ax_cart_message', JSON.stringify(obj));
    // }
}

export default Cart;
